// Список элементов меню
var navItems = [
    {text: 'Счетчики',      active: false,  slug: 'apartment_meters_data',      state: 'root.meters'},
    {text: 'Начисления',    active: false,  slug: 'all_apartments_accruals',    state: 'root.accruals'},
    {text: 'Оплаты',        active: false,  slug: 'all_apartments_accruals',    state: 'root.payments'},
    {text: 'Заявки',        active: false,  slug: 'request_log',                state: 'root.requests'},
    {text: 'Обращения',     active: false,  slug: 'tickets_from_tenants',       state: 'root.tickets'},
    {text: 'Новости',       active: false,  slug: 'news',                       state: 'root.news'},
    {text: 'Настройки',     active: false,  slug: 'apartment_meters_data',      state: 'root.account'}
];

// Список интервалов для запроса информации о счетчиках
var meterIntervals = [
    { value: 1,  text: 'последний месяц' },
    { value: 6,  text: 'последние полгода' },
    { value: 12, text: 'последний год' },
    { value: 24, text: 'последние два года' },
    { value: 36, text: 'последние три года' }
];

// Типы заявок
var requestTypes = [
    { value: 'false', text: 'Мои заявки', color: '#80ae46', status: 'Подана Вами',     chartStatus: 'Подано Вами' },
    { value: 'true',  text: 'Все заявки', color: '#627cab', status: 'Подана соседями', chartStatus: 'Подано соседями' }
];

// Количество элементов
var itemsLimit = [
    { value: '10',   text: '10 элементов' },
    { value: '20',   text: '20 элементов' },
    { value: '30',   text: '30 элементов' },
    { value: '40',   text: '40 элементов' },
    { value: '50',   text: '50 элементов' },
    { value: '60',   text: '60 элементов' },
    { value: '70',   text: '70 элементов' },
    { value: '80',   text: '80 элементов' },
    { value: '90',   text: '90 элементов' },
    { value: '100',  text: '100 элементов' },
    { value: '110',  text: '110 элементов' },
    { value: '120',  text: '120 элементов' },
    { value: '130',  text: '130 элементов' },
    { value: '140',  text: '140 элементов' },
    { value: '150',  text: '150 элементов' }
];

// Цвета статуса заявок
var requestStatusColor = [
    { value: 'performed',   color: 'green' },
    { value: 'accepted',    color: 'white' },
    { value: 'run',         color: 'yellow' },
    { value: 'abandonment', color: 'red' },
    { value: 'delayed',     color: 'red' },
    { value: 'refusal',     color: 'red' }
];

// Цвета статуса обращений
var ticketStatusColor = [
    { value: 'new',       color: 'white' },
    { value: 'published', color: 'white' },
    { value: 'closed',    color: 'green' },
    { value: 'accepted',  color: 'yellow' }
];

// Типы ответов на заявки
var ticketAnswers = [
    { value: 'new',       text: 'Принято к рассмотрению' },
    { value: 'published', text: 'Не опубликовано' },
    { value: 'closed',    text: 'Дан ответ' },
    { value: 'accepted',  text: 'Подготовка ответа' }
];

// Типы обращений
var ticketTypes = [
    { value: 'statement',    text: 'Заявление' },
    { value: 'claim',        text: 'Претензия' },
    { value: 'complaint',    text: 'Жалоба' },
    { value: 'notification', text: 'Уведомление' },
    { value: 'letter',       text: 'Письмо' },
    { value: 'offer',        text: 'Предложение' },
    { value: 'gratitude',    text: 'Благодарность' }
];

// Типы задолженостей
var balanceTypes = [
    { value: false, text: 'Суммарная переплата' },
    { value: true,  text: 'Суммарная задолженность' }
];

// Виды состояний лицевого счета
var balanceValues = [
    { value: false, text: 'Сумма долга'},
    { value: true,  text: 'Переплата'}
];

// Иконки типов новостей
var newsIcon = [
    { value: 'sys_offer' ,  icon: 'question' },
    { value: 'release' ,    icon: 'refresh' },
    { value: 'tech_works' , icon: 'wrench' },
    { value: 'sys_notify' , icon: 'bell' },
    { value: 'good_know' ,  icon: 'commenting' },
    { value: 'info' ,       icon: 'info' }
];

// Варианты цветового оформления
var styleList = [
    { value: 'blue',    text: 'Синяя' },
    { value: 'green',   text: 'Зеленая' },
    { value: 'pink',    text: 'Фиолетовая' },
    { value: 'orange',  text: 'Дерево' },
    { value: 'newYear', text: 'Новогодняя' },
    { value: 'dark',    text: 'Темная' }
];

// Варианты размера шрифта
var fontList = [
    { value: 'min',     text: 'Обычный' },
    { value: 'normal',  text: 'Средний' },
    { value: 'big',     text: 'Большой' }
];

// Список представлений новостей
var newsView = [
    { value: 'tile', text: 'Плитка' },
    { value: 'list', text: 'Список' }
];

// Количество новостей в области уведомлений
var newsLimit = [
    { value: '1',   text: '1 шт' },
    { value: '3',   text: '3 шт' },
    { value: '5',   text: '5 шт' },
    { value: '10', text: '10 шт' },
    { value: '15', text: '12 шт' },
    { value: '20', text: '20 шт' }
];

// Стандартные ответы - да/нет
var trueFalse = [
    { value: 'true',  text: 'Да' },
    { value: 'false', text: 'Нет' }
];

var trueFalseBoolean = [
    { value: true,  text: 'Да' },
    { value: false, text: 'Нет' }
];

var settingsName = [
    { value: 'userStyle',      text: 'Настройки оформления' },
    { value: 'userFont',       text: 'Настройки оформления' },
    { value: 'metersInterval', text: 'Настройки счетчиков' },
    { value: 'requestsType',   text: 'Настройки заявок' },
    { value: 'newsView',       text: 'Настройки оформления новостей' },
    { value: 'userNews',       text: 'Настройки оформления' },
    { value: 'requestsLimit',  text: 'Настройки заявок' },
    { value: 'ticketsLimit',   text: 'Настройки обращений' },
    { value: 'newsLimit',      text: 'Настройки новостей' },
    { value: 'useBlur',        text: 'Настройки оформления' },
    { value: 'useAnimate',     text: 'Настройки оформления' },
    { value: 'mailNotify',     text: 'Личные настройки ' },
    { value: 'notifies',       text: 'Настройки уведомлений' }
];

// Список неочищаемых данных
var noRemoveData = ['dictionaries', 'constants', 'userFont', 'userStyle', 'userNews', 'useAnimate', 'metersInterval', 'requestsType', 'requestsLimit', 'ticketsLimit', 'newsLimit', 'newsView'];